import React from 'react';

import {
  Popover,
  OverlayTrigger,
} from 'react-bootstrap';


const CustPopover = props => {

    const popoverClick = (
      <Popover id={props.id} title={props.title} style={{maxWidth: '100%'}}>
        {props.content}
      </Popover>
    );

    return (
      <OverlayTrigger trigger="click" placement={props.placement} overlay={popoverClick}>
        {props.trigger}
      </OverlayTrigger>
    );
}

export default CustPopover;




// WEBPACK FOOTER //
// ./src/commonComponents/CustPopover.jsx